import { Stack } from '@mui/material';
import { Doc } from 'src/@types/docs';
import { useAuthContext } from 'src/auth/useAuthContext';
import { WorkspaceShareMembersAvatar } from 'src/features/workspace/WorkspaceShareMembersAvatar';
import { DocOptionsMenu } from './DocOptionsMenu';
import { FavoriteDocHeaderAction } from './FavoriteDocButton';
import { NewDocButton } from './NewDocButton';
import { PinDocHeaderAction } from './PinDocButton';
import { ShareDocButton } from './ShareDocButton';
import { SharedWithYou } from './SharedWithYou';

type Props = {
  doc: Doc;
  handlePrint: () => void;
};

export const HeaderActions = ({ doc, handlePrint }: Props) => {
  const { user } = useAuthContext();

  return (
    <>
      <Stack
        gap={{ xs: 0.5, sm: 2.5 }}
        direction="row"
        alignItems="center"
        alignSelf={{ xs: 'flex-end', md: 'center' }}
        justifyContent="space-between"
        overflow="auto"
        mt={{ xs: 2, sm: 0 }}
      >
        {doc.owner !== user?._id && <SharedWithYou />}

        <WorkspaceShareMembersAvatar
          members={doc.participants}
          size="small"
          max={6}
        />

        <NewDocButton doc={doc} />

        {doc.owner === user?._id && <ShareDocButton docId={doc?._id} />}

        <Stack direction="row" alignItems="center" gap={0.5}>
          <FavoriteDocHeaderAction doc={doc} />

          <PinDocHeaderAction doc={doc} />

          <DocOptionsMenu doc={doc} handlePrint={handlePrint} />
        </Stack>
      </Stack>
    </>
  );
};
